import React from 'react';
import Highlights from './Highlights'
import i18n from '../i18n/index.js'
import '../scss/HeroVideo.scss';

function HeroVideo() {
    return (
      <section className="HeroVideo">
        <video autoPlay loop muted  id="myVideo" playsInline>
            <source src="/assets/hero.mp4" type="video/mp4" fileConfig={{ attributes: { playsinline: true }}} autoPlay/>
        </video>
        <div className="titleHome">
            <div className="container">
              <div className="d-none d-md-flex align-items-end h-80">
                  <Highlights classNameH="homeH" 
                  firstLineH={i18n.t('home.Banner.titleFirstLineHighlight')} firstLine={i18n.t('home.Banner.titleFirstLine')} 
                  secondLineH={i18n.t('home.Banner.titleSecondLineHighlight')}secondLine={i18n.t('home.Banner.titleSecondLine')} 
                  onEnterViewport= { () => console.log('') }/>
              </div>
              <div className="d-flex d-md-none align-items-end h-80">
                  <Highlights classNameH="homeH" 
                  firstLineH="MANÍ" 
                  secondLineH="LA EVOLUCI"secondLine="ÓN" 
                  thirthLineH=" " thirthLine="de nuestro campo"/>
              </div>
            </div>
        </div>
       <img className="deco-01" src="/assets/deco-grey.svg" alt="deco"/>
      </section>
    );
  }
  
  export default HeroVideo;